var showroomConfiguration;

(function () {

    let exteriorWalls = [
        [-6.75, -5.25],
        [-6.75, 2.25],
        [0, 6.75],
        [6.75, 2.25],
        [6.75, -5.25],
        [3.75, -6.75],
        [-3.75, -6.75]
    ];
    
    exteriorWalls = exteriorWalls.map(p => p.map(n => n * (1.1)));
    console.log(exteriorWalls);
    let string = ""
    for (let w of exteriorWalls) {
        string += w[0] + " " + (w[1] - 5.25) + ","
    }
    console.log(string);
    
    showroomConfiguration = {
        sky: "assets/hangar.jpg",
        models: [
            {
                id: "turbine",
                path: "assets/turbine/turbine.gltf",
                x: 0,
                y: 0.5,
                z: -1.5,
                scale: 0.5,
                nearbyDom: {
                    radius: 1.8,
                    target: '#ar-popup'
                }
            },
            {
                id: "question",
                path: "assets/question/scene.gltf",
                x: 3.5,
                y: 0.8,
                z: 4.6,
                scale: 0.4,
                animation: "property: rotation; to: 0 360 0; loop: true; dur: 10000; easing: linear;",
                nearbyDom: {
                    radius: 1.5,
                    target: '#question-popup'
                }
            },
            {
                id: "door",
                path: "assets/door/garage_door.gltf",
                x: 0,
                y: 0,
                z: -7.42,
                scale: 4.0
            }
        ],
        roomCoordinates: exteriorWalls,
        internalWallCoordinates: [
            [-2.8, 0.15], [2.8, 0.15], [2.8, -0.15], [-2.8, -0.15]
        ],
        textures: {
            'wall-0': "assets/walls/btc-wall0.png",
            'wall-1': "assets/walls/btc-wall1.png",
            'wall-2': "assets/walls/btc-wall2.png",
            'wall-3': "assets/walls/btc-wall3.png",
            'wall-4': "assets/walls/btc-wall4.png",
            'wall-5': "assets/walls/btc-wall5.png",
            'wall-6': "assets/walls/btc-wall6.jpg",
            'wall-7': "assets/walls/btc-wall7.png",
            'wall-8': "assets/walls/btc-wall8.png",
            'wall-9': "assets/walls/btc-wall9.png",
            'wall-10': "assets/walls/btc-wall10.png",
        },
        scale: 1,
        startPosition: [0, 5.25],
        videos: [{
            path: "assets/david-waving.mp4",
            position: {
                x: 0,
                y: 0.9,
                z: 1
            },
            loop: true,
            muted: true,
            autoplay: true,
            isGreenScreen: true,
            height: 720 * (2 / 720),
            width: 408 * (2 / 720),
            billboard: true
        }, {
            path: "assets/jet-aviation.mp4",
            position: {
                x: -2,
                y: 0,
                z: -0.01
            },
            rotation: {
                x: 0,
                y: 180,
                z: 0
            },
            width: 1280 * (3.5 / 1280),
            height: 720 * (3.5 / 1280),
            nearbyReveal: {
                animate: false,
                radius: 2.5
            },
            spatialAudio: {
                min: 1,
                max: 3
            },
            parent: 'wall-1',
            thumbnail: 'assets/video-thumbnail.jpg'
        }]
    };
}());
